import { RSK_CHAIN_ID } from '../config/chains';
import { useLoadContract } from './useLoadContract';
export const useGetProtocolContract = (contractName, chain = RSK_CHAIN_ID, customSigner) => useLoadContract(contractName, 'protocol', chain, customSigner);
export const useGetTokenContract = (contractName, chain = RSK_CHAIN_ID, customSigner) => useLoadContract(contractName, 'assets', chain, customSigner);
